import { render } from "./Myself.vue?vue&type=template&id=7e4d4bd9"
import script from "./Myself.vue?vue&type=script&lang=js"
export * from "./Myself.vue?vue&type=script&lang=js"
script.render = render

export default script